export const ENLIGHTEN_APP_SUBPATH = "/enlighten-app";

export const SCROLL_TARGETS = {
  TEAM_LEADERBOARD: "team-leaderboard"
} as const;

export const PIPELINE_CONFIG_SYNC_DEBOUNCE_MS = 2000;
